export default __webpack_public_path__ + "static/media/logo_leskoski.d9c9a8f4.png";